
import { Component, OnInit, AfterViewInit, Inject, DOCUMENT } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { helperService } from 'src/app/utils/helper';

@Component({
    selector: 'app-horizontaltopbar',
    templateUrl: './horizontaltopbar.component.html',
    styleUrls: ['./horizontaltopbar.component.scss'],
    standalone: false
})

/**
 * Horizontal-Topbar Component
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {
  menuItems: MenuItem[] = [];
  element:any;
  flagvalue:any;
  cookieValue:any;
  countryName:any;
  valueset:any;

  constructor(@Inject(DOCUMENT) private document: any, 
  private router: Router, 
  public translate: TranslateService,
  public languageService: LanguageService,
  public _cookiesService: CookieService,
  public auth:AuthGuard,
  public helperService:helperService
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
  }

  /***
   * Language listing
   */
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  ngOnInit(): void {
    this.element = document.documentElement;
    this.initialize();
    /***
     * Language value cookies wise set
     */
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    console.log(MENU);
    let menuItems = MENU;
    const roles = this.auth.roles;
    let latestMenu = menuItems.filter((item: any) => {
      if (item.roles) {
        return item.roles.some((val: any) => roles.includes(val));
      } else {
        return true;
      }
    });

    latestMenu = latestMenu.map((item: any) => {
      if (item.subItems) {
        item.subItems = item.subItems.filter((subItem: any) => {
          return subItem.roles.some((val: any) => roles.includes(val));
        });
      }
      return item;
    });

    console.log(latestMenu);
    this.menuItems=latestMenu

    // if(this.auth.roles.includes("LPC") && this.auth.roles.includes("TK") && !this.auth.roles.includes("ADMIN")){
    //   this.menuItems=MENU.filter(obj=>obj.label!="Admin"&&obj.label!="Reports");
    // }else  if(this.auth.roles.includes("ADMIN")){
    //   this.menuItems = MENU;
    //   if(this.auth.roles.includes("TK") && !this.auth.roles.includes("LPC")){
    //     for(let obj of this.menuItems){
    //       obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="LPC"):obj.subItems
    //     }
    //   }
    //   else if(!this.auth.roles.includes("TK") && this.auth.roles.includes("LPC")){
    //     this.menuItems=this.menuItems.filter((val:any)=>val.label!='TK Availability');
    //     for(let obj of this.menuItems){
    //       obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="Timekeeper"):obj.subItems
    //     }
    //   }
    //   // if(this.auth.roles.includes("LPC") ){
    //   //   for(let obj of this.menuItems){
    //   //     obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="Timekeeper"):obj.subItems
    //   //   }
    //   // }
    // }else if(this.auth.roles.includes("LPC") && this.auth.roles.length==1){
    //   this.menuItems=MENU.filter(obj=>obj.label!="Admin"&&obj.label!='TK Availability'&&obj.label!="Reports");
    //   for(let obj of this.menuItems){
    //     obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="Timekeeper"):obj.subItems
    //   }
    // }else if(this.helperService.isOnlyTKUser(this.auth.roles)){
    //   this.menuItems=MENU.filter(obj=>obj.label!="Admin"&&obj.label!="Organizations"&&obj.label!="Matters"&&obj.label!="Reports");
    //   for(let obj of this.menuItems){
    //     obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="LPC"):obj.subItems
    //   }
    // }else if(this.auth.roles.includes("TK")  && this.auth.roles.includes("LPC") ){
    //   this.menuItems=MENU.filter(obj=>obj.label!="Admin"&&obj.label!="Organizations"&&obj.label!="Reports");
    //   for(let obj of this.menuItems){
    //     obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="Timekeeper"):obj.subItems
    //   }
    // }else if(this.auth.roles.includes("LPC") ){
    //   this.menuItems=MENU.filter(obj=>obj.label!="Admin"&&obj.label!='TK Availability'&&obj.label!="Reports");
    //   for(let obj of this.menuItems){
    //     obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="Timekeeper"):obj.subItems
    //   }
    // }else if(this.auth.roles.includes("TK") ){
    //   this.menuItems=MENU.filter(obj=>obj.label!="Admin"&&obj.label!="Organizations"&&obj.label!="Matters"&&obj.label!="Reports");
    //   for(let obj of this.menuItems){
    //     obj.subItems=obj.subItems?obj.subItems.filter((val:any)=>val.label!="LPC"):obj.subItems
    //   }
    // }else if(this.auth.roles.includes("Billing") &&this.auth.roles.length==1){
      
    // } else{
    //   this.menuItems = MENU;
    // }
    // this.menuItems = MENU;
    
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * On menu click
   */
  onMenuClick(event: any) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove('show');
      }
      // Close any other open flyout so only one top-level menu is open at a time
      // (keep the clicked menu and the ancestor chain of the clicked element open).
      document.querySelectorAll('.topnav .dropdown-menu.show').forEach((menu: any) => {
        if (menu !== nextEl && !menu.contains(event.target)) {
          menu.classList.remove('show');
        }
      });
      nextEl.classList.toggle('show');
    }
    return false;
  }

  ngAfterViewInit() {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activates the menu
   */
  private activateMenu() {
    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
                const menuelement = document.getElementById(
                  'topnav-menu-content'
                );
                if (menuelement !== null)
                  if (menuelement.classList.contains('show'))
                    document
                      .getElementById('topnav-menu-content')!
                      .classList.remove('show');
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links: any = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
              }
            }
          }
        }
      }
    }
  }
}
